import { z } from 'my-zod'
import { customersModel } from '../../customer-operations/customer/customers-model'
import { subscriptionPlanModel } from '../../select-membership/subscription-plan'
import { customerSubscriptionModel } from './customer-subscription-model'

export const customerSubscriptionSystemView = customerSubscriptionModel.augment({
  planName: subscriptionPlanModel.shape.name,
  customerShortId: customersModel.shape.shortId,
  customerFirstName: customersModel.shape.firstName,
  customerLastName: customersModel.shape.lastName
})
export type customerSubscriptionSystemView = z.infer<typeof customerSubscriptionSystemView>
